import axios from "axios";

// Global axios configuration - cookies for authentication
axios.defaults.withCredentials = true;

// Request interceptor
axios.interceptors.request.use(
  (config) => {
    config.withCredentials = true;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor with retry logic for transient failures
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    const status = error.response?.status;

    // Retry on 5xx or network errors (max 2 retries)
    if (!config.__retryCount && (status >= 500 || !error.response)) {
      config.__retryCount = (config.__retryCount || 0) + 1;
      if (config.__retryCount <= 2) {
        await new Promise((r) => setTimeout(r, 1000 * config.__retryCount));
        return axios(config);
      }
    }

    // Skip auth-related endpoints to avoid loops
    const url = error.config?.url || "";
    const isAuthEndpoint = url.includes("/api/auth/");
    const skipAuthError = error.config?.headers?.["X-Skip-Auth-Error"] === "true";

    if (status === 401 && !isAuthEndpoint && !skipAuthError) {
      window.dispatchEvent(new CustomEvent("app:auth-required"));
    } else if (status === 403) {
      // Skip upgrade modal for super_admin / admin (paywall should never gate them)
      // and for clearly non-paywall 403s like role-based denials.
      let isPrivileged = false;
      try {
        const raw = localStorage.getItem("markeemix_user");
        const u = raw ? JSON.parse(raw) : null;
        if (u && (u.role === "super_admin" || u.role === "admin" || u.is_super_admin || u.plan === "pro" || u.plan === "enterprise")) {
          isPrivileged = true;
        }
      } catch { /* noop */ }
      const detail = (error.response?.data?.detail || "").toString().toLowerCase();
      const looksLikePaywall = /upgrade|pro plan|premium|trial|subscribe|pricing/.test(detail);
      if (!isPrivileged && (looksLikePaywall || !detail || detail === "forbidden")) {
        window.dispatchEvent(
          new CustomEvent("app:upgrade-required", {
            detail: error.response?.data?.detail || "Upgrade required",
          })
        );
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
